import Button from "@material-ui/core/Button";
import Collapse from "@material-ui/core/Collapse";
import TextField from "@material-ui/core/TextField";
import get from "lodash/get";
import React, { Component } from "react";
import Select from "react-select";
import CheckImg from "../../../../../Assets/Images/aaa.png";
import SectionHeaderExtraSmall from "../../../../../Component/Headers/sectionHeaderExtraSmall";
import { ErrorMessages } from "../../../../../Constants";
import { getSelectValue } from "../../../../../Utils";
import Dropzone from "react-dropzone";
import CloseIcon from "@material-ui/icons/Close";
import Add from "@material-ui/icons/Add";
import { instanceMultipart } from "Actions/AxiosInstance";

export default class Form extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isbuopen: false,
      businessunitheadid: null,
      bulogofile: null,
      bulogoPreview: null,
    };
    this.removeImg = this.removeImg.bind(this);
    this.getFiles1 = this.getFiles1.bind(this);
  }

  componentDidMount() {
    this.setState({
      isbuopen: this.props.postData.businessunitheadid,
      businessunitheadid: this.props.postData.businessunitheadid,
      bulogoPreview: this.props.postData.bulogopath ? this.props.getFormattedImageLink(this.props.postData.bulogopath) : null
    });
    this.props.onRef({
      onCancel: this.props.onCancel,
      onNext: this._onsubmit,
      nextButtonLabel: "Save",
    });
  }

  _onChange = (key, value) => {
    const { postData } = this.props;
    const newPostData = { ...postData };

    if (key === "isbuopen") {
      if (value) {
        this.setState({
          [key]: value,
          businessunitheadid: newPostData.businessunitheadid,
        });
      } else {
        this.setState({
          [key]: value,
          businessunitheadid: null,
        });
        newPostData.businessunitheadid = null;
      }
    } else {
      newPostData[key] = value;
    }

    delete newPostData.isbuopen;
    this.props.updatePostData(newPostData);
  };

  getFiles1(acceptedFiles) {
    const file = acceptedFiles[0];
    if (!file) {
      this.props.enqueueSnackbar("Please select a valid image. (Max size: 2MB)", {
        variant: "error",
      });
      return false;
    }
    const formData = new FormData();
    formData.append("file", file);

    const subscriptionid = get(this.props, "SubscriptionInfo.SubscriptionData.subscriptionid", "");
    const accountid = get(this.props, "SubscriptionInfo.SubscriptionData.accountid", "");
    const documentfor = "0";
    
    instanceMultipart
      .post(
        `/subscription/uploaddefault/${accountid}/${subscriptionid}/${documentfor}`,
        formData,
      )
      .then((resp) => {
        const bulogopath = get(resp, 'data.result[0].imagepath', null);
        if (bulogopath) {
          const newPostData = { ...this.props.postData, bulogopath };
          this.props.updatePostData(newPostData);
          this.setState({
            bulogofile: file,
            bulogoPreview: URL.createObjectURL(file),
          });
          this.props.enqueueSnackbar("Logo uploaded successfully.", { variant: "success" });
        } else {
          this.props.enqueueSnackbar("Failed to upload business unit logo.", { variant: "error" });
        }
      })
      .catch((error) => {
        this.props.enqueueSnackbar("An error occurred during logo upload.", { variant: "error" });
      });
  }

  removeImg() {
    const newPostData = { ...this.props.postData, bulogopath: null };
    this.props.updatePostData(newPostData);
    this.setState({ bulogofile: null, bulogoPreview: null });
  };

  _onsubmit = () => {
    const { businessunitname } = this.props.postData;
    const { isentity } = this.props;

    if (!businessunitname) {
      this.props.enqueueSnackbar(ErrorMessages.E1300, { variant: "error" });
      return;
    } else if (this.state.isbuopen && !this.props.postData.businessunitheadid) {
      this.props.enqueueSnackbar(ErrorMessages.E1310, { variant: "error" });
      return;
    }

    !isentity && this.props._submit();
  };

  render() {
    const {
      businessunitname,
      officeaddressid,
      businessunitheadid,
    } = this.props.postData;

    const { isbuopen, bulogoPreview } = this.state;

    return (
      <div>
        <div className="form-group">
          <p className="depedent-select-list-head">Business Unit Name</p>
          <TextField
            id="outlined-dense"
            margin="dense"
            variant="outlined"
            autoComplete="off"
            style={{ width: "50%" }}
            placeholder="Enter Business unit name"
            onChange={(e) => this._onChange("businessunitname", e.target.value)}
            value={businessunitname}
            maxLength="100"
            className="form-text-input"
            autoFocus
          />
        </div>
        <div className="margin-bottom-20 width50">
          <p className="depedent-select-list-head">Location (Optional)</p>
          <Select
            className="selectsearch"
            onChange={(e) => this._onChange("officeaddressid", e.displayvalue)}
            options={get(this.props, "initData.OfficeAddress", [])}
            getOptionLabel={(option) => option.displayname}
            getOptionValue={(option) => option.displayvalue}
            value={getSelectValue(
              get(this.props, "initData.OfficeAddress", []),
              officeaddressid
            )}
            placeholder="Select"
          />
        </div>
        <div className="margin-top-20">
          <p className="depedent-select-list-head">Business Unit Logo (Optional)</p>
          <div className="display-flex" style={{ justifyContent: "left" }}>
            {!bulogoPreview && (
              <span className="add-attachment" style={{ width: 180, height: 60 }}>
                <Dropzone
                  onDrop={this.getFiles1}
                  multiple={false}
                  accept="image/gif, image/jpeg, image/png, image/jpg"
                  maxSize={2000000}
                  style={{ marginTop: 2, textAlign: "center", padding: 10 }}
                >
                  <Add className="add-attachement-icon" style={{ marginLeft: 0, marginTop: 0 }} />
                  <div style={{ fontSize: 12 }}>Upload Business Unit logo</div>
                </Dropzone>
              </span>
            )}
            {bulogoPreview && (
              <div
                style={{
                  padding: 2,
                  borderRadius: 5,
                  border: "1px solid #cdcdcd",
                  height: 60,
                  width: 180,
                }}
              >
                <img
                  className="floatleft"
                  style={{ objectFit: "contain" }}
                  src={bulogoPreview}
                  height="60"
                  width="148"
                />
                <CloseIcon
                  style={{ backgroundColor: "#ffff", height: 16 }}
                  onClick={this.removeImg}
                />
              </div>
            )}
          </div>
          <p className="input-label">
            Note: Upload photo with max size 2 MB for optimum results.
            (Supports .gif, .jpeg, .jpg and .png file types)
          </p>
        </div>

        {/* Assign Business Unit Head */}
        <div className="margin-top-20 width50">
          <p className="depedent-select-list-head">
            Do you want to assign a Business Unit Head? (Optional)
          </p>
          <div
            className="depedent-select-list"
            onClick={() => this._onChange("isbuopen", true)}
            aria-expanded={isbuopen}
          >
            <span>Yes</span>
            {isbuopen ? (
              <span className="floatright">
                <img src={CheckImg} height="20" />
              </span>
            ) : (
              <span className="not-selected" />
            )}
          </div>
          <div className="et-level2 width100 margin0">
            <Collapse
              in={isbuopen}
              timeout={2}
              unmountOnExit
              className="padding20 overflow-initial"
            >
              <p className="depedent-select-list-head">Business unit head</p>
              <Select
                className="selectsearch"
                onChange={(e) => this._onChange("businessunitheadid", e.displayvalue)}
                options={get(this.props, "initData.Employee", [])}
                getOptionLabel={(option) => option.displayname}
                getOptionValue={(option) => option.displayvalue}
                value={getSelectValue(
                  get(this.props, "initData.Employee", []),
                  businessunitheadid
                )}
                placeholder="Select"
              />
            </Collapse>
          </div>
          <div
            className="depedent-select-list"
            onClick={() => this._onChange("isbuopen", false)}
            aria-expanded={!isbuopen}
          >
            <span>No</span>
            {!isbuopen ? (
              <span className="floatright">
                <img src={CheckImg} height="20" />
              </span>
            ) : (
              <span className="not-selected" />
            )}
          </div>
        </div>

        <div className="margin-top-20" />
      </div>
    );
  }
}